import axios from '../request'
import youth_axios from '../request/youth'
import romt_axios from '../request/rmt'
export default{
    getBook(data){//获取活动信息
        return axios({
            url:'/portal/tougao/qchhrList ',
            method:'post',
            data
        })
    },
    getlist(data){//获取列表
        return axios({
            url:'/portal/tougao/getQcList',
            method:'post',
            data
        })
    },
    getlists(data){//获取列表
        return axios({
            url:'/portal/theme/getList',
            method:'post',
            data
        })
    },
    getUserInfo(data = {}){//获取用户信息
        return axios({
            url:`/portal/tougao/getUserInfo`,
            method:'post',
            data
         })
     },
      toUp(data = {}){//给作品点赞
        return axios({
            url:`https://pub-userapi.voc.com.cn/Tougao/tougaoUp `,
            method:'post',
            data
         })
     },
    getCertificate(data = {}){//获取证书
        return axios({
            url:`/portal/tougao/qchhrCertificate`,
            method:'post',
            data
         })
     },
     sendCode(data = {}){//发送验证码
        return axios({
            url:`/portal/tougao/mobileSendCode`,
            method:'post',
            data
         })
     },
     wechatMobile(data = {}){//绑定手机号
        return axios({
            url:`/portal/tougao/wechatMobile`,
            method:'post',
            data
         })
     },
     getActive(data = {}){//获取活动信息
        return axios({
            url:'https://m.voc.com.cn/portal/tougao/active',
            method:'get',
            params:data
         })
     },
     hjlogin(data = {}){//登录
        return youth_axios({
            url:'/api/login/hjlogin',
            method:'post',
            data
         })
     },
     sendCode(data = {}){//获取验证码
        return youth_axios({
            url:'/api/sms/sendCode',
            method:'post',
            data
        })
    },
    certList(data = {}){//获取证书列表
        return youth_axios({
            url:'/api/certificate/search',
            method:'get',
            params:data
        })
    },
    // 点赞接口
    like(data = {}){
        return romt_axios({
            url:`/v5/comment/newsupdate`,
            method:'post',
            data
        })
    },
    getCertImage(data = {}){//获取证书图片地址
        return youth_axios({
            url:`/api/certificate/obtain`,
            method:'post',
            data
        })
    },
}